import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';


const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*',
'Access-Control-Allow-Credentials': 'true', 'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS'});

@Injectable({
  providedIn: 'root'
})

export class VersionService {

  latestVersionUrl = '/superadmin/rest/mgmt/version';

  constructor(private http: HttpClient) { }

  getLatestVersion(): Observable<any> {
     return this.http.get(this.latestVersionUrl, {headers: headers});
  }
  updateVersion(value): Observable<any> {
     return this.http.put(this.latestVersionUrl, value, { headers: headers });

  }
  verifyOtp(otp): Observable<any> {
    return this.http.post(this.latestVersionUrl + '/' + otp + '/verify', { headers: headers });
  }
}
